/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntelligenceExcelCell = {
  value: any;
  format_type: IntelligenceExcelCell.format_type;
  decimals?: number;
  currency_symbol?: string;
  suffix?: string;
  thousands_separator?: boolean;
};
export namespace IntelligenceExcelCell {
  export enum format_type {
    CURRENCY = 'currency',
    PERCENTAGE = 'percentage',
    NUMBER = 'number',
    DATE = 'date',
    TEXT = 'text',
    BOOLEAN = 'boolean',
  }
}

